export const Colors = {
  primary: "#fc8575",
  "gris-clair": "#e0e0e0",
  saumon: "#fc8575",
  gray: "#979797",
  colorBack: "#FFB6C1",
  colorBtn: "#555555",
  colorIcon: "#555555",
};
